<template>
    <div class="uk-grid-small" uk-grid>
        <div
            v-for="(inputField, key) in fields"
            :key="'ia' + inputField.name"
            :class="
                key > 0 && !isFull
                    ? 'uk-width-1-2@s uk-width-1-1'
                    : 'uk-width-1-1'
            ">
            <TextField
                v-model="inputField.value"
                is-round
                :autocomplete="inputField.autocomplete"
                :field-key="key"
                :icon="inputField.icon"
                :is-optional="inputField.optional"
                :label="inputField.label"
                :name="inputField.name"
                :on-enter="onEnter"
                :rules="inputField.rules"
                :type="inputField.type"
                :disabled="disabled"
                :validate="validate"
                @setValid="setValid"
                :has-keyboard="hasKeyboard" />
        </div>
        <div class="uk-width-1-1">
            <LabelWithError :label="$t('country') + '*'" />
            <form autocomplete="off">
                <select
                    :value="value"
                    name="country"
                    :disabled="getInfos.shippingCountries.length === 1"
                    class="uk-select uk-input-styled studio-round"
                    v-on:change="$emit('input', $event.target.value)">
                    <option
                        v-for="option in getInfos.shippingCountries"
                        :key="option"
                        :value="option">
                        {{ $t(option) }}
                    </option>
                </select>
            </form>
        </div>
    </div>
</template>

<script>
import TextField from '@/components/generic/TextField';
import LabelWithError from '@/components/generic/LabelWithError';

// the checkout's address: under the delivery type for shipping, under the
// payment method when only "invoice" asks for it
export default {
    name: 'AddressFields',
    components: {TextField, LabelWithError},
    props: {
        // the view's addressFields; TextField's v-model writes their value
        fields: Array,
        value: String,
        disabled: Boolean,
        validate: Number,
        onEnter: Function,
        hasKeyboard: Boolean,
        isFull: Boolean,
    },
    methods: {
        setValid(valid, fieldKey) {
            this.$emit('setValid', valid, fieldKey);
        },
    },
};
</script>

<style lang="scss" scoped>
// the views' own .studio-round is scoped and does not reach in here
.studio-round {
    border-radius: $border-radius-next;
}
</style>
